module.exports = __webpack_public_path__ + "static/img/view4-3.baaa563.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view4-3.png
// module id = unjb
// module chunks = 1